import AvailabilityFilter from "#ce/shared/filters/availability/components/AvailabilityFilter.ce.vue";
import BooleanFilter from "#ce/shared/filters/boolean/components/BooleanFilter.ce.vue";
import CategoryFilter from "#ce/shared/filters/category/components/CategoryFilter.ce.vue";
import DateFilter from "#ce/shared/filters/date/components/DateFilter.ce.vue";
import DistanceFilter from "#ce/shared/filters/distance/components/DistanceFilter.ce.vue";
import InsurancePlanFilter from "#ce/shared/filters/insurance-plan/components/InsurancePlanFilter.ce.vue";
import ProviderFilter from "#ce/shared/filters/provider/components/ProviderFilter.ce.vue";
import SpecialtyFilter from "#ce/shared/filters/specialty/components/SpecialtyFilter.ce.vue";
import VisitTypeFilter from "#ce/shared/filters/visit-type/components/VisitTypeFilter.ce.vue";

/** The filter component each `type` renders. `props.js` holds the props of the same types. */
export const filterComponents = Object.freeze({
  availability: AvailabilityFilter,
  boolean: BooleanFilter,
  category: CategoryFilter,
  date: DateFilter,
  distance: DistanceFilter,
  insurance: InsurancePlanFilter,
  provider: ProviderFilter,
  specialty: SpecialtyFilter,
  visitType: VisitTypeFilter,
});
